// extracted by mini-css-extract-plugin
export var quantityInput = "_ny-0";